

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.222","height":"27.093"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd","transform":"rotate(90 10.635 11.482)"}, [h('path', {"stroke":"#FFF","stroke-linecap":"round","stroke-width":"1.5","d":"M3.464 17.608a7.5 7.5 0 0 1 5.89-13.153"}, []), h('path', {"fill":"#FFF","d":"M8.222 1.398a.75.75 0 0 1 1.06.055l2.341 2.601a.75.75 0 0 1-.055 1.06l-.012.009-2.59 2.332a.75.75 0 0 1-1.003-1.114L10.006 4.5l-1.84-2.043a.75.75 0 0 1 .056-1.06Z"}, []), h('path', {"stroke":"#FFF","stroke-linejoin":"round","stroke-width":"1.5","d":"M15.027 9.27V3.886c0-1.105.816-2 1.823-2h6.605c1.007 0 1.822.895 1.822 2V9.27"}, []), h('rect', {"width":"9.75","height":"18.5","x":"11.371","y":"7.242","stroke":"#FFF","stroke-width":"1.5","rx":"2","transform":"rotate(90 16.246 16.492)"}, [])])]);
};

        